import { Injectable } from '@angular/core';
import { ShopModeService } from '@service/helpers/shop-mode.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatService
{
  public changeChatState = new Subject<{ state: string, message: string }>();

  constructor(private shopModeService: ShopModeService) { }

  public disable(): void
  {
    this.changeChatState.next({ state: "disable", message: '' });
  }
  public enable(): void
  {
    this.changeChatState.next({ state: "enable", message: '' });
  }


  public open(message: string = null, productName: string = null): void
  {
    if (this.shopModeService.isRuggo)
    {
      let text = message;

      if (productName)
      {
        let text = "Ahoj, rád bych se dozvěděl více o produktu " + productName;
      }

      if ((window as any).$crisp)
      {
        (window as any).$crisp.push(["do", "chat:open"]);
        (window as any).$crisp.push(["set", "message:text", [text]]);
      }
    }
    else
    {
      this.changeChatState.next({ state: "show", message: message });
    }
  }
  public hide(): void
  {
    this.changeChatState.next({ state: "hide", message: '' });
  }
}
